export const PENDING_STATUS = 'pendente'
export const APPROVED_STATUS = 'approved'
export const REJECTED_STATUS = 'disapproved'

export const statusOptions = [
    { name: 'Pendente', value: PENDING_STATUS },
    { name: 'Aprovado', value: APPROVED_STATUS },
    { name: 'Rejeitado', value: REJECTED_STATUS }
]